module.exports = __webpack_public_path__ + "assets/img/provider-02.5b9e942c.jpg";